export default __webpack_public_path__ + "static/cookie-d300c9ef6ba744dcfc105fa2522c0029.png";